var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('TheHeader'),_c('v-main',{staticClass:"grey lighten-4"},[_c('v-container',{staticClass:"pa-0 ma-auto",style:({
          backgroundImage: 'url(' + _vm.bgImage + ')',
          backgroundRepeat: 'repeat',
          backgroundSize: '250px',
          backgroundAttachment: 'fixed'
        }),attrs:{"fluid":"","fill-height":"","align-start":"","justify-center":""}},[_c('v-card',{attrs:{"width":"900","flat":"","color":"rgb(0, 0, 0, 0)"}},[_c('router-view')],1)],1),_c('NewVersionDialog')],1),_c('TheFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }